<template>
  <div class="dark-footer" v-if="$store.state.stylist">
    <action-bar></action-bar>
  </div>
</template>

<script>

import ActionBar from './action-bar'
export default {
  name: 'dark-footer',
  components: {
    ActionBar
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style type="text/css">

  .dark-footer {
    position: fixed;
    z-index: 1000;
    bottom: 0px;
    right: 0px;
    background: #FFF;
    min-width: 100%;
    -webkit-box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.2);
    box-shadow: 0 0 2rem 0 rgba(0, 0, 0, 0.2);
    padding: 5px 10px 0 5px;
    -webkit-transition: all .25s linear;
    transition: all .25s linear;
    color: #000;
  }
  @media (min-width: 768px) {
    .dark-footer {
      min-width: 355px;
    }
  }

</style>
